import React from "react";
import Footer from "./atoms/Footer/Footer";
import Header from "./atoms/Header/Header";
import Homepage from "./components/homepage/Homepage";
import RouteController from "./routes/RouteController";

const Main = () => {
  return (
    <>
      <RouteController />
    </>
  );
};

export default Main;
